import React, {Component} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavLink} from 'reactstrap';
import {MediaEndpoints, NotificationEndpoints, UsersEndpoints} from '../../common/ProxyEndpoints';
import ProfileAvatar from "../ProfileAvatar/ProfileAvatar";
import Utils from "../../common/Utils";
import HTML from '../../common/HtmlHelpers';
import CreateAdminAccount from '../../components/CreateAdminAccount';
import Confirm from '../../components/Confirm';
import ChangeAccountPassword from "../ChangeAccountPassword/ChangeAccountPassword";
import UserProfile from '../../views/UserProfile';
import PlatformRender from "../PlatformRender/PlatformRender";
import {DevicePlatforms, Permissions, UserRoles} from "../../common/Constants";
import {notifyLogout} from "../../common/Events/EventSource";
import TTLProxy from "../../common/TTLAsyncProxy";
import UserNotifications from "../UserNotifications/UserNotifications";
import './Header.css';
import ChangeEmail from "../ConfirmUserUpdate/ChangeEmail";
import ChangePhone from "../ConfirmUserUpdate/ChangePhoneNumber";
import AccountControlDialog from "../AccountControlDialog/AccountControlDialog";
import TrackerMapDialog from "../TrackerMapDialog/TrackerMapDialog";
import FeedbackDialog from "../FeedbackDialog/FeedbackDialog";
import EventActions from "../../common/Events/Actions";
import AuditExplorer from "../AuditExplorer/AuditExplorer";
import PermissionRender from "../PermissionRender/PermissionRender";
import WalletManagement from "../WalletManagement/WalletManagement";
import EventListener from "../../common/EventListener";
import history from '../../history';

class Header extends Component {

    constructor(props) {

        super(props);

        this.toggle = this.toggle.bind(this);

        this.proxy = TTLProxy.getInstance();

        this.state = {
            dropdownOpen: false,
            user: this.proxy.getUserInfo(),
            media: null,
            isBusy: false,
            notificationSummary: {

                tractor_requests: {
                    total: 0,
                    seen: 0,
                    unseen: 0
                },

                alert: {
                    total: 0,
                    seen: 0,
                    unseen: 0
                },

                geo: {
                    total: 0,
                    seen: 0,
                    unseen: 0
                },

                other: {
                    total: 0,
                    seen: 0,
                    unseen: 0
                }
            }
        };

        this.eventSubscriptions = [
            { event: EventActions.UserProfileImageUpdated , callback: this.onProfilePictureUpdated.bind(this) },
            { event: EventActions.UserInfoUpdated , callback: this.onUserInfoUpdated.bind(this) },
            { event: EventActions.ShowChangeEmail , callback: this.onShowChangeEmail.bind(this) },
            { event: EventActions.ShowChangePhone , callback: this.onShowChangePhone.bind(this) } ,
            { event: EventActions.NotificationUpdate, callback: this.onUpdateNotificationsHint.bind(this)}
        ];

        this.handleEvent = this.handleEvent.bind(this);

        this._isMounted = false;
    }

    setStateSafe(state){

        if(this._isMounted)
            this.setState(state);
    }

    /**
     * Refreshes the state of the view
     **/
    loadState(){

        const me = this;
        const proxy = this.proxy;
        const user = this.state.user;

        return Promise.all([

            //  check profile picture update
            proxy.processRequest(MediaEndpoints.checkExists(user.role, Utils.getUserEntityId(user)  )).then((response) =>{

                me.setStateSafe({
                    media: response.getPayload()
                });

            }),

            //  check user notifications
            this.onUpdateNotificationsHint()

        ]);
    }

    handleEvent(event,data){
        return this.eventSubscriptions.find(x => x.event === event).callback(data);
    }

    onUpdateNotificationsHint(){

        return this.proxy.processRequest(NotificationEndpoints.getSummary()).then(response => {

            this.setStateSafe({
                notificationSummary : response.getPayload()
            });

        });
    }

    componentDidMount(){
        this._isMounted = true;
        return this.loadState();
    }


    componentWillUnmount(){
        this._isMounted = false;
    }

    //-------------------------------------
    //  Event Listeners
    //-------------------------------------

    onProfilePictureUpdated(media){
        return this.loadState();
    }

    onUserInfoUpdated(user){
        this.setStateSafe({ user: user });
    }

    onShowChangeEmail(){
        this._changeEmail.show();
    }

    onShowChangePhone(){
        this._changePhone.show();
    }

    //-------------------------------------

    toggle() {
        this.setStateSafe({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    asideToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
    }

    onLogout() {

        const me = this;
        const proxy = this.proxy;
        const history  = this.props.history;

        if(proxy.isAuthenticated()){

            return proxy.signOut().then((response) => {

                //   notify other parts of the application of user logout
                notifyLogout();

                //  navigate to login
                window.location.href = "/login";

                return false; // don't close dialog

            }).catch((err) => {

                HTML.toastWarning(  ( 'isConnectionError' in err && err.isConnectionError() )? 'Oops! We lost connection. Try again!' : 'Something went wrong!');
                return true; // close dialog immediately
            });

        }

    }

    onViewProfile(){
        this._userProfileDlg.show();
    }

    hasRole(role){
        let userRole = this.proxy.getUserRole();
        return Utils.hasRole(userRole , role);
    }


    getTotalUnseenNotifications(){
        const s = this.state.notificationSummary;
        return s.tractor_requests.unseen + s.alert.unseen + s.other.unseen + s.geo.unseen;
    }

    onUserUpdated(){

        const proxy = TTLProxy.getInstance();

        //  update user info
        return proxy.processRequest( UsersEndpoints.getMyself() ).then(response => {
            const user = response.getPayload();
            proxy.setUserInfo(user);
        });

    }


    render() {

        const name = Utils.getUserName(this.state.user) || (Utils.ucFirst(this.state.user.role));
        const unseenNotifications = this.getTotalUnseenNotifications();

        const isAdmin = this.hasRole(UserRoles.Admin);
        const isOwner = this.hasRole(UserRoles.Owner);

        return (<EventListener events={this.eventSubscriptions.map(x => x.event)} onEvent={this.handleEvent}>

                <header className="app-header navbar">
                    <button className="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" onClick={this.mobileSidebarToggle}>&#9776;</button>
                    <a className="navbar-brand" href="#"></a>
                    <ul className="nav navbar-nav d-md-down-none">
                        <li className="nav-item">
                            <button className="nav-link navbar-toggler sidebar-toggler" type="button" onClick={this.sidebarToggle}>&#9776;</button>
                        </li>
                        <li className="nav-item px-3">
                            <NavLink href="/dashboard">Dashboard</NavLink>
                        </li>
                    </ul>

                    <ul className="nav navbar-nav ml-auto">

                        <li className="nav-item d-md-down-none" style={{ minWidth: 'inherit' }}>
                            <a className="nav-link" href="#" onClick={(evt) => {
                                evt.preventDefault();
                                this._feedbackDlg.show();
                            }}><i className="fa fa-smile-o" style={{ fontSize: 18 }}></i></a>
                        </li>

                        <PermissionRender roles={[ UserRoles.Admin , UserRoles.Owner ]} required={[ Permissions.User.ReadNotifications ]}>
                            <li className="nav-item d-md-down-none">
                                <a className="nav-link" href="#" onClick={(evt) => {
                                    evt.preventDefault();
                                    this._userNotificationsDlg.show();
                                }}><i className="icon-bell"></i> {unseenNotifications > 0 && <span className="badge badge-pill badge-danger">{unseenNotifications}</span>}</a>
                            </li>
                        </PermissionRender>

                        <li className="nav-item">
                            <Dropdown isOpen={this.state.dropdownOpen} className="ml-2" toggle={this.toggle} >

                                <DropdownToggle onClick={this.toggle}  className="nav-link dropdown-toggle" data-toggle="dropdown" type="button">

                                    <PlatformRender platform={DevicePlatforms.Desktop}>
                                        <span style={{color: 'black' , 'marginRight' : '5px'}} className="hidden-lg">{name}</span>
                                    </PlatformRender>

                                    <ProfileAvatar showFullscreen={false} media={this.state.media} name={Utils.formatAvatarName(name)} size={32}/>

                                </DropdownToggle>

                                <DropdownMenu className="dropdown-menu-right" style={{ left: 'inherit' }}>
                                    <DropdownItem header className="text-center"><strong>Account</strong></DropdownItem>
                                    <DropdownItem disabled={this.proxy.isSuperUser()} onClick={() => this.onViewProfile()}><i className="fa fa-user"></i>Profile</DropdownItem>

                                    <PermissionRender required={[ Permissions.User.ChangePassword ]}>
                                        <DropdownItem onClick={() => this._changeAccountPwd.show() }><i className="fa fa-lock"></i>Change Password</DropdownItem>
                                    </PermissionRender>

                                    <PermissionRender required={[ Permissions.User.ChangePhone ]}>
                                        <DropdownItem disabled={this.proxy.isSuperUser()} onClick={() => this._changePhone.show() }><i className="fa fa-phone"></i>Change Phone No.</DropdownItem>
                                    </PermissionRender>

                                    <PermissionRender required={[ Permissions.User.ChangeEmail ]}>
                                        <DropdownItem disabled={this.proxy.isSuperUser()} onClick={() => this._changeEmail.show() }><i className="fa fa-envelope"></i>Change Email</DropdownItem>
                                    </PermissionRender>

                                    <PermissionRender required={[ Permissions.Wallet.Manage ]} roles={[ UserRoles.FBO , UserRoles.Farmer ]}>
                                        <DropdownItem onClick={() => this._walletManagementDlg.show() }><i className="fa fa-credit-card"/> Manage Wallet</DropdownItem>
                                    </PermissionRender>

                                    <DropdownItem onClick={() => this._feedbackDlg.show() }><i className="fa fa-comment"></i>Submit feedback</DropdownItem>
                                    {/*<DropdownItem onClick={() => NavigationHelper.navigate('/account/tickets')}><i className="fa fa-ticket"></i> Tickets (Manage & Submit) </DropdownItem>*/}

                                    <PermissionRender roles={[ UserRoles.Admin , UserRoles.Owner ]} required={[ Permissions.User.ReadNotifications ]}>
                                        <DropdownItem onClick={() => this._userNotificationsDlg.show() }><i className="fa fa-bell"></i>Notifications</DropdownItem>
                                    </PermissionRender>

                                    {isAdmin && <DropdownItem header className="text-center"><strong>Actions</strong></DropdownItem>}

                                    {/* Account Management Dialog */}
                                    {this.proxy.isSuperUser() && <DropdownItem onClick={() => this._accountControlDlg.show() }><i className="fa fa-users"></i>Account Control</DropdownItem>}

                                    {/* Audit Explorer*/}
                                    <PermissionRender superUser>
                                        <DropdownItem onClick={() => this._auditExplorer.show() }><i className="fa fa-folder"></i>Audit Explorer</DropdownItem>
                                    </PermissionRender>

                                    {/*Register New Admin Account */}
                                    <PermissionRender required={[ Permissions.Admin.Create ]}>
                                        <DropdownItem onClick={() => this._createAdminDlg.show() }><i className="fa fa-user-plus"></i>Register Administrator</DropdownItem>
                                    </PermissionRender>

                                    {/*Command Agric Payments*/}
                                    <PermissionRender required={[ Permissions.CommandAgriculture.View ]} roles={[ UserRoles.Admin ]}>
                                        <DropdownItem onClick={() => history.push('/finance/command/agric/payments')}><i className="fa fa-bank"/> CBZ Payments</DropdownItem>
                                    </PermissionRender>

                                    {/*Map Trackers Dialog*/}
                                    <PermissionRender roles={[ UserRoles.Admin ]} required={[ Permissions.Trackers.View ]}>
                                        {isAdmin && <DropdownItem onClick={() => this._trackerMapDlg.show()}><i className="fa fa-gears"></i> Configure Tracking Devices</DropdownItem>}
                                    </PermissionRender>

                                    <DropdownItem divider/>

                                    <DropdownItem onClick={() => this._signoutDlg.show() }><i className="fa fa-lock"></i>Logout</DropdownItem>
                                </DropdownMenu>

                            </Dropdown>

                        </li>

                        <li className="nav-item d-md-down-none">
                            <button className="nav-link navbar-toggler aside-menu-toggler" type="button" onClick={this.asideToggle}>&#9776;</button>
                        </li>

                    </ul>

                    {/*Change account password*/}
                    <ChangeAccountPassword
                        ref={(input) =>{
                            this._changeAccountPwd = input;
                        }}/>


                    {/* SignOut confirm dialog */}
                    <Confirm
                        confirmText="Yes, Sign Out"
                        cancelText="Cancel"
                        onConfirm={() => this.onLogout()}
                        body="Are you sure you want to sign out?"
                        confirmBtnColor="danger"
                        title="Confirm Logout"
                        ref={(input) =>{
                            this._signoutDlg = input;
                        }}/>

                    {/* Confirm phone*/}
                    <ChangePhone closeAfterChanged={true} ref={r => this._changePhone = r } onChanged={this.onUserUpdated.bind(this)} />

                    {/** Confirm email */}
                    <ChangeEmail closeAfterChanged={true} ref={r => this._changeEmail = r } onChanged={this.onUserUpdated.bind(this)} />

                    {/*User Profile dialog**/}
                    <UserProfile ref={(input) => this._userProfileDlg = input }/>

                    {/*Shows notifications for user account*/}
                    <UserNotifications ref={(input) => this._userNotificationsDlg = input}/>

                    {/*Feedback submit dialog*/}
                    <FeedbackDialog ref={input => this._feedbackDlg = input}/>

                    <WalletManagement ref={r => this._walletManagementDlg = r} colCount={3}/>

                    {/* For administrator accounts*/}

                    {isAdmin && <AccountControlDialog ref={input => this._accountControlDlg = input}/>}

                    {isAdmin && <CreateAdminAccount ref={(input) =>{ this._createAdminDlg = input}}/>}

                    {isAdmin && <TrackerMapDialog ref={input => this._trackerMapDlg = input }/>}

                    {isAdmin && <AuditExplorer ref={r => this._auditExplorer = r}/>}

                </header>
        </EventListener>)
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js